<template>
  <div class="p-chat-subject-picker">
    <p-loading v-if="loading" size="md" />

    <!-- Pill buttons per Figma node 5192:16544. Click immediately starts the chat. -->
    <div v-else class="p-chat-subject-picker__list">
      <button
        v-for="s in subjects"
        :key="s.id"
        class="p-chat-subject-picker__pill"
        type="button"
        @click="emit('start', s.id, s.name)"
      >
        <span class="p-chat-subject-picker__pill-label f-body-14-medium t-fg-primary">
          {{ s.name }}
        </span>
        <p-icon icon="caret-right" size="sm" color="fg-primary" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Subject } from '@p-backoffice/helpdesk-sdk'

defineProps<{
  subjects: Subject[]
  loading: boolean
}>()

const emit = defineEmits<{
  start: [subjectId: number, firstMessage: string]
}>()
</script>

<style lang="scss" scoped>
// Figma node 5192:16544 — Chat Suggestions
// Pills hug their content, lined up to the left, content-width.

.p-chat-subject-picker {
  // Vertical padding only; horizontal padding comes from PChatContainer body.
  padding: 8px 0;

  &__list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  &__pill {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 40px;
    padding: 0 16px;
    background: transparent;
    border: 1px solid var(--stroke-strong);
    border-radius: 999px;
    cursor: pointer;
    text-align: left;
    transition: background-color 0.15s;

    &:hover {
      background-color: var(--bg-gray-light);
    }
  }

  &__pill-label {
    font-size: 14px;
    line-height: 22px;
    font-weight: 500;
    white-space: nowrap;
  }
}
</style>
